/**
 * Shared DTOs for the mobile medications/supplements records viewer.
 *
 * The web API owns parity + normalization, while mobile renders these
 * read-only payloads directly to avoid duplicating FHIR joins client-side.
 */
export interface MobileRecordProtocolContext {
  title: string;
  content: string;
}

export interface MobileRecordItem {
  id: string;
  name: string;
  dosage?: string;
  frequency?: string;
  notes?: string;
  prescriberName?: string;
  startDate?: string;
  protocolContext?: MobileRecordProtocolContext;
}

export interface MobileRecordsResponse<TRecord extends MobileRecordItem = MobileRecordItem> {
  generatedAt: string;
  active: TRecord[];
  inactive: TRecord[];
}

export interface MobileMedicationRecord extends MobileRecordItem {}

export interface MobileMedicationRecordsResponse
  extends MobileRecordsResponse<MobileMedicationRecord> {}

export interface MobileSupplementRecord extends MobileRecordItem {}

export interface MobileSupplementRecordsResponse
  extends MobileRecordsResponse<MobileSupplementRecord> {}
